import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { ActionIcon } from '@ui/components/ActionIcon'
import { CloseIcon } from '@ui/icons/Close.icon'
import { WarningIcon } from '@ui/icons/Warning.icon'

import styles from './SystemNotification.module.scss'

interface SystemNotificationProps {
  title: string
  close?(): void
  readMore?: () => void
}

export const SystemNotification = (props: SystemNotificationProps) => {
  const { title, close, readMore } = props
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <WarningIcon color='text-white' />
        <Body2 isParagraph color='text-white' medium>
          {title}
          {readMore && (
            <>
              {' '}
              <Body2 className={styles.readMore} medium decoration='underline' onClick={readMore}>
                {t('Notifications.Read more')}
              </Body2>
            </>
          )}
        </Body2>
        {!!close && <ActionIcon icon={{ icon: CloseIcon, color: 'text-white' }} onClick={close} />}
      </div>
    </div>
  )
}
